import { ColorType } from "lightweight-charts";
import { IAmcChartDataRequest } from "../../interfaces/AMCChartData.interface";

export const sharesColors = {
  orange: "#fcd362",
  navyBlue: "#4a6784",
  blue: "#74a9f2",
  pinkPastel: "#ffa7C7",
  brown: "#dd8b6a",
  yellow: "#faba0a",
  lightBlue: "#d3dae1",
  black: "#1a1a1a",
  greyCloud: "#f2f2f2",
  white: "#ffffff",
  greenDeep: "#067161",
  red: "#660000",
};
export const chartOptions = {
  height: 225,
  grid: {
    vertLines: { visible: true, color: sharesColors.greyCloud },
    horzLines: { visible: true, color: sharesColors.greyCloud },
  },
  watermark: {
    visible: false,
  },
  layout: {
    fontSize: 12,
    lineHeight: 16,
    fontColor: sharesColors.black,
    family: "Rubik",
    textColor: sharesColors.black,
    background: { type: ColorType.Solid, color: sharesColors?.white },
  },
  handleScroll: false,
  handleScale: false,
  timeScale: {
    timeVisible: true,
    secondsVisible: false,
    ticksVisible: false,
    rightOffset: 1,
    borderColor: "transparent",
    fixLeftEdge: true,
    fixRightEdge: true,
    minimumHeight: 0,
  },
  crosshair: {
    horzLine: {
      visible: false,
      labelVisible: false,
    },
    vertLine: {
      labelVisible: false,
    },
  },
  rightPriceScale: {
    borderColor: sharesColors.greyCloud,
  },
  leftPriceScale: {
    borderColor: sharesColors.greyCloud,
  },
};

export const graphDurationBtns = ["1W", "1M", "3M", "6M", "1Y", "3Y", "5Y"];
export const graphOptionData: Partial<IAmcChartDataRequest> = {
  fromDate: new Date().toISOString().slice(0, 10),
  toDate: new Date().toISOString().slice(0, 10),
  interval: "1",
};

export const formatChartPrice = (price: number): string => `₹${price.toFixed(2)}`;

export const chartPriceFormat = {
  type: "custom" as const,
  formatter: formatChartPrice,
  minMove: 0.01,
};

export type SchemeReturnField =
  "oneWeek" | "oneMonth" | "threeMonth" | "sixMonth" | "oneYrRet" | "threeYrRet" | "fiveYrRet";

export type SchemeReturns = Partial<Record<SchemeReturnField, number | string | null>>;

export const durationReturnConfig: Record<string, { field: SchemeReturnField; suffix: string }> = {
  "1W": { field: "oneWeek", suffix: " for last 1 week" },
  "1M": { field: "oneMonth", suffix: " for last 1 month" },
  "3M": { field: "threeMonth", suffix: " for last 3 months" },
  "6M": { field: "sixMonth", suffix: " for last 6 months" },
  "1Y": { field: "oneYrRet", suffix: " annually for last 1 yr" },
  "3Y": { field: "threeYrRet", suffix: " annually for last 3 yrs" },
  "5Y": { field: "fiveYrRet", suffix: " annually for last 5 yrs" },
};

export const DEFAULT_DURATION_LABELS: Record<string, string> = {
  "1W": "1 week",
  "1M": "1 month",
  "3M": "3 months",
  "6M": "6 months",
  "1Y": "1 yr",
  "3Y": "3 yrs",
  "5Y": "5 yrs",
};

export const DEFAULT_UNAVAILABLE_RETURN_HEADING = "No data available for {durationLabel}";
